import { c as _c } from "react/compiler-runtime";
import JsonLdScript from '@/components/json-ld/JsonLdScript';
import { ORGANIZATION_JSON_LD } from '@/constants/organization-schema';
const OrganizationJsonLd = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <JsonLdScript data={ORGANIZATION_JSON_LD} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default OrganizationJsonLd;